import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Stack, CircularProgress
} from '@mui/material';
import { useKeycloak } from '@react-keycloak/web';
import Config from '../../ckcore/core/Config';
import User from '../../ckcore/core/User';
import { Roles, getRoleName, getRoleStatus } from '../../ckcore/core/Roles';
import TxStatus from '../../ckcore/core/TxStatuses';

export default function RemoveStaffDialog({ open, onClose, partnerId, staff }) {
  const { keycloak } = useKeycloak();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const enableRemoved = () => {
    // can not change owner
    if (staff.role === Roles.ADMIN && !User.isOwner()) {
      return false;
    }

    // can not removed my self
    if (staff.email === User.getEmail()) {
      return false;
    }

    // can not change success
    if (staff.statusId === TxStatus.SUCCESS) {
      return false;
    }

    return true;
  }

  const handleRemoveStaff = async () => {
    if (!staff.userId) {
      setMessage({ type: 'error', text: 'Thiếu userId Keycloak' });
      return;
    }
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const resp = await fetch(`${Config.getServerStaffURL()}/staff/${staff.id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${keycloak.token}` }
      });

      const data = await resp.json();

      if (resp.ok) {
        setMessage({ type: 'success', text: 'Xoá thành viên thành công!' });
        setTimeout(onClose, 1500);
      } else {
        setMessage({ type: 'error', text: data.message || 'Lỗi khi xoá thành viên' });
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'Lỗi mạng hoặc server' });
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Xoá thành viên</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <Typography>
            Bạn có chắc muốn xoá <strong>{staff.username || staff.email}</strong> khỏi tổ chức?
          </Typography>
          <Typography>
            Lưu ý: Chỉ xoá được khi người dùng đang bị khoá.
          </Typography>
          {message.text && (
            <Typography color={message.type === 'error' ? 'error' : 'success.main'}>
              {message.text}
            </Typography>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Hủy</Button>
        <Button
          variant="outlined" color="error"
          onClick={handleRemoveStaff}
          disabled={loading || !enableRemoved()}
          startIcon={loading && <CircularProgress size={16} color="inherit" />}
        >
          Xoá
        </Button>
      </DialogActions>
    </Dialog>
  );
}
